import { OverflowTooltipLabel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import clsx from 'clsx';

interface OverflowHandlerProps {
    children?: string;
    content?: string;
    className?: string;
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right' | 'mouse';
}

export default function OverflowHandler({
    children,
    content,
    className,
    tooltipPosition = 'top',
}: OverflowHandlerProps): ReactNode {
    const text = content ?? children ?? '';

    return (
        <OverflowTooltipLabel
            label={text}
            className={clsx('text-truncate block', className)}
            tooltipPosition={tooltipPosition}
        />
    );
}
